import { render } from "./auditlog.cattle.io.auditpolicy.vue?vue&type=template&id=896c8e7e&ts=true"
import script from "./auditlog.cattle.io.auditpolicy.vue?vue&type=script&lang=ts"
export * from "./auditlog.cattle.io.auditpolicy.vue?vue&type=script&lang=ts"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__